import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { Users, DollarSign, ShoppingCart, TrendingUp } from "lucide-react";

const Dashboard = () => {
  // 示例数据
  const salesData = [
    { name: "Jan", value: 4000 },
    { name: "Feb", value: 3000 },
    { name: "Mar", value: 2000 },
    { name: "Apr", value: 2780 },
    { name: "May", value: 1890 },
    { name: "Jun", value: 2390 },
  ];

  const userActivityData = [
    { name: "Mon", active: 3000 },
    { name: "Tue", active: 3500 },
    { name: "Wed", active: 2780 },
    { name: "Thu", active: 4090 },
    { name: "Fri", active: 3490 },
    { name: "Sat", active: 2380 },
    { name: "Sun", active: 2190 },
  ];

  const stats = [
    {
      title: "Total Users",
      value: "12,361",
      icon: <Users className="text-blue-500" />,
      trend: "+12%",
    },
    {
      title: "Total Revenue",
      value: "$34,890",
      icon: <DollarSign className="text-green-500" />,
      trend: "+8%",
    },
    {
      title: "Total Orders",
      value: "23,456",
      icon: <ShoppingCart className="text-purple-500" />,
      trend: "+15%",
    },
    {
      title: "Growth",
      value: "18.2%",
      icon: <TrendingUp className="text-orange-500" />,
      trend: "+3%",
    },
  ];

  return (
    <div className="space-y-6">
      {/* Stats Grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{stat.title}</p>
                <p className="text-2xl font-semibold">{stat.value}</p>
              </div>
              <div className="p-3 bg-gray-50 rounded-full">{stat.icon}</div>
            </div>
            <div className="mt-4">
              <span className="text-green-500 text-sm font-medium">
                {stat.trend}
              </span>
              <span className="text-gray-500 text-sm ml-2">vs last month</span>
            </div>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* Sales Chart */}
        <div className="p-6 bg-white rounded-lg shadow-sm">
          <h2 className="text-lg font-semibold mb-4">Monthly Sales</h2>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={salesData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#4F46E5" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* User Activity Chart */}
        <div className="p-6 bg-white rounded-lg shadow-sm">
          <h2 className="text-lg font-semibold mb-4">User Activity</h2>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={userActivityData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="active"
                  stroke="#4F46E5"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow-sm">
        <div className="p-6">
          <h2 className="text-lg font-semibold mb-4">Recent Activity</h2>
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((item) => (
              <div
                key={item}
                className="flex items-center justify-between py-3 border-b last:border-0"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 bg-gray-100 rounded-full"></div>
                  <div>
                    <p className="font-medium">User Action {item}</p>
                    <p className="text-sm text-gray-500">2 hours ago</p>
                  </div>
                </div>
                <button className="text-blue-500 hover:text-blue-600">
                  View
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
